module.exports = __webpack_public_path__ + "img/globe-nav-chevron-right-white.72f2ac48.svg";